import React, { useState } from "react";
import { Button, ButtonGroup, Dialog, DialogTitle, DialogContent, Typography, Divider, Box } from "@mui/material";
import { Save, ArrowBack } from "@mui/icons-material";
import { global, projectStatus } from "../../context/global";
import { advanceStatus } from "./ProjectActions";
import { useDispatch } from "react-redux";

export default function StepperButtons({ payload, saveAction, saveActionArguments, updateStatus = true, warningPopup = false, loopManagementTabs }) {
    const dispatch = useDispatch();
    const editmode = payload.editable && saveAction;
    const [showPopup, setShowPopup] = useState(false);

    const currentPhase = payload.activeStep.phase
    const currentStep = payload.activeStep.step
    const currentLoop = payload.activeStep.loop
    const {phases} = payload.project

    // This is a context that is used for the loop setup tabs
    const isLoopManagementTabContext = loopManagementTabs && typeof loopManagementTabs.tabIndex === "number" && loopManagementTabs.tabCount > 0 && typeof loopManagementTabs.setTabIndex === "function";

    const scrollToTop = () => {
        window.scrollTo(0, 80);
    }

    const handleNextStep = () => {
        scrollToTop();
        if (isLoopManagementTabContext) {
            const { tabIndex, tabCount, setTabIndex } = loopManagementTabs;
            if (tabIndex < tabCount - 1) {
                setTabIndex(tabIndex + 1);
                return;
            }
        }
        if (editmode) {
            if (saveActionArguments) {
                saveAction(saveActionArguments);
            } else {
                saveAction();
            }
        }
        if (updateStatus) {
            advanceStatus(payload.project.id, { status: currentStep }, dispatch);
            payload.handleNextStep();
        } else if (warningPopup) {
            setShowPopup(true);
        } else {
            payload.handleNextStep();
        }
    };

    const handlePreviousStep = () => {
        scrollToTop();
        if (isLoopManagementTabContext) {
            const { tabIndex, setTabIndex } = loopManagementTabs;
            if (tabIndex > 0) {
                setTabIndex(tabIndex - 1);
                return;
            }
        }
        payload.handlePreviousStep();
    }



    return (
        <Box sx={{ marginTop: "auto" }}>
            <Dialog open={showPopup}>
                <DialogTitle>{projectStatus[currentStep]?.label} vergrendelen</DialogTitle>
                <DialogContent>
                    <Typography>
                        Wil je de {projectStatus[currentStep]?.label} vergrendelen? Dit is noodzakelijk om latere stappen te kunnen
                        voltooien, maar kan alleen teruggedraaid worden door organisatie administrators.
                        <br />
                        <br />
                        {currentStep >= 1 ? "Dit vergrendeld ook alle voorgaande stappen" : ""}
                    </Typography>
                </DialogContent>
                <ButtonGroup sx={{ marginLeft: "auto", marginRight: "auto" }}>
                    <Button
                        onClick={() => {
                            setShowPopup(false);
                        }}
                    >
                        <ArrowBack />
                        Terug
                    </Button>
                    <Button
                        onClick={() => {
                            setShowPopup(false);
                            scrollToTop();
                            payload.handleNextStep();
                        }}
                    >
                        Niet vast zetten
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => {
                            advanceStatus(payload.project.id, { status: currentStep }, dispatch);
                            setShowPopup(false);
                            scrollToTop();
                            payload.handleNextStep();
                        }}
                    >
                        Vast zetten
                    </Button>
                </ButtonGroup>
            </Dialog>


            <Divider sx={{ marginTop: 6, marginBottom: 2 }} />
            <ButtonGroup sx={{ display: "block" }}>
                {currentPhase === 0 && currentLoop === 0 && currentStep === 0 ? (
                    ""
                ) : (
                    <Button sx={{ paddingLeft: "25px", paddingRight: "25px" }} onClick={handlePreviousStep}>
                        {global.previous} {global.step}
                    </Button>
                )}
                {
                    (
                        currentPhase < phases.length ||
                        (currentPhase - 1 >= 0 &&
                            currentLoop < phases[currentPhase - 1].loops.length - 1) ||
                        currentStep < payload.steps[currentPhase].steps.length - 1) && (
                        <Button sx={{ paddingLeft: "25px", paddingRight: "25px" }} onClick={handleNextStep}>
                            {editmode && (
                                <>
                                    <Save />
                                    {global.save} {global.and}
                                </>
                            )}{" "}
                            {global.next} {global.step}
                        </Button>
                    )}
            </ButtonGroup>
        </Box>
    );
}
